import { isGoogleMapsLink, linkifyHtmlPhoneNumbersToMarkdown } from '@frontend/duck-tape';
import { useMemo } from '@frontend/react';
import { GoogleMapsIcon } from '@frontend/web-icons';
import { YStack } from '@frontend/web-react';
import { concatClasses, safeCss } from '@frontend/web-utils';
import Markdown, { defaultUrlTransform } from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

type RenderMarkdownProps = {
  children: string;
  className?: string;
  onLinkClick?: (href: string) => void;
};

export const RenderMarkdown = ({ children, className, onLinkClick }: RenderMarkdownProps) => {
  const markdownBody = useMemo(() => linkifyHtmlPhoneNumbersToMarkdown(children), [children]);

  return (
    <YStack className={className}>
      <Markdown
        components={{
          a: ({ children, className: linkClassName, href, node: _node, ...rest }) => (
            <a
              {...rest}
              className={concatClasses(safeCss('underline-offset-2 underline inline-flex items-center'), linkClassName)}
              href={href}
              onClick={(e) => {
                if (onLinkClick && href) {
                  e.preventDefault();
                  onLinkClick(href);
                }
              }}
              rel="noopener noreferrer"
              target="_blank"
            >
              {children}
              {href && isGoogleMapsLink(href) ? (
                <span className={safeCss('ml-[2px] inline-flex')}>
                  <GoogleMapsIcon height={16} width={16} />
                </span>
              ) : null}
            </a>
          ),
        }}
        remarkPlugins={[remarkGfm, remarkBreaks]}
        urlTransform={(url, _key, _node) => (url.startsWith('tel:') ? url : defaultUrlTransform(url))}
      >
        {markdownBody}
      </Markdown>
    </YStack>
  );
};
